import React from "react";
import useStepPersistence from "../../Hooks/useStepPersistience";
import PersonInformation from "../../organisms/KNT/PersonInformation";
const PersonInformationContainer = ({ formData, errors, setFormStep, loading, setPreviousStep, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        person_type: undefined,
        company_name: "",
        family_name: "",
        initials: "",
        given_names: "",
        gender: undefined,
    }, formData, setFormStep);
    return (React.createElement(PersonInformation, { setPreviousStep: setPreviousStep, onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), errors: errors, loading: loading }));
};
export default PersonInformationContainer;
